import type { AllRouteEndpoints } from "../routeTypes";
export const alloysShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorsExportCacheKeys: AllRouteEndpoints[] = [
  "/alloys/shopify/:app_group_id/bridges/:bridge_id/catalog_item_errors_export",
];
